// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

// ------------------------------------
// Constants
// ------------------------------------

/* obtener cuestionarios */
export const GET_QUESTIONS = 'GET_QUESTIONS'
export const GET_QUESTIONS_FAILED = 'GET_QUESTIONS_FAILED'
export const GET_QUESTIONS_SUCCEEDED = 'GET_QUESTIONS_SUCCEEDED'

/* obtener cuestionarios por id */
export const GET_QUESTIONS_ID = 'GET_QUESTIONS_ID';
export const GET_QUESTIONS_ID_FAILED = 'GET_QUESTIONS_ID_FAILED';
export const GET_QUESTIONS_ID_SUCCEEDED = 'GET_QUESTIONS_ID_SUCCEEDED';

/* validar si el usuario es apto para ejecutar ejecutar la simulación */
export const USER_IS_SUITABLE = 'USER_IS_SUITABLE'
export const USER_IS_SUITABLE_FAILED = 'USER_IS_SUITABLE_FAILED'
export const USER_IS_SUITABLE_SUCCEEDED = 'USER_IS_SUITABLE_SUCCEEDED'

/* Enviar el contrado por email */
export const SEND_CONTRACT = 'SEND_CONTRACT'
export const SEND_CONTRACT_FAILED = 'SEND_CONTRACT_FAILED'
export const SEND_CONTRACT_SUCCEEDED = 'SEND_CONTRACT_SUCCEEDED'


/* obtener cuestionarios */
export const GET_PAIS = 'GET_PAIS'
export const GET_PAIS_FAILED = 'GET_PAIS_FAILED'
export const GET_PAIS_SUCCEEDED = 'GET_PAIS_SUCCEEDED'

export const SET_ESTADO_CUESTIONARIOS = "SET_ESTADO_CUESTIONARIOS";

// ------------------------------------
// Actions
// ------------------------------------
export function getQuestions(token, callback) {
  return {
    type : GET_QUESTIONS,
    token,
    callback
  }
}

export function getQuestionsFailed(error) {
  return {
    type: GET_QUESTIONS_FAILED,
    error
  }
}

export function getQuestionsSucceeded(inclusion, socio_demografico, salida, socioCampaign, menosSaludableCampaign, campaignSatisfaction) {
  return {
    type : GET_QUESTIONS_SUCCEEDED,
    payload : { questInclusion: inclusion, questSocioDemografico: socio_demografico, questSalida: salida, questCampaign: socioCampaign, questSalidaCampaign: menosSaludableCampaign, questCampaignSatisfaction: campaignSatisfaction }
  }
}

export function getPais(callback) {
  return {
    type : GET_PAIS,
    callback
  }
}

export function getPaisFailed(error) {
  return {
    type: GET_PAIS_FAILED,
    error
  }
}

export function getPaisSucceeded(pais) {
  return {
    type : GET_PAIS_SUCCEEDED,
    payload : { paises: pais }
  }
}

export function getQuestionsId(token, term, callback) {
    return {
        type : GET_QUESTIONS_ID,
        token,
        term,
        callback
    }
}

export function getQuestionsIdFailed(error) {
    return {
        type: GET_QUESTIONS_ID_FAILED,
        error
    }
}

export function getQuestionsIdSucceeded( quest ) {
    return {
        type : GET_QUESTIONS_ID_SUCCEEDED,
        payload : quest
    }
}

export function userIsSuitable(token, term, callback) {
  return {
    type: USER_IS_SUITABLE,
    token,
    term,
    callback
  }
}

export function userIsSuitableFailed(error) {
  return {
    type: USER_IS_SUITABLE_FAILED,
    error
  }
}

export function userIsSuitableSucceeded() {
  return {
    type: USER_IS_SUITABLE_SUCCEEDED
  }
}

export function sendContract(token, term, callback) {
  return {
    type: SEND_CONTRACT,
    token,
    term,
    callback
  }
}

export function sendContractFailed(error) {
  return {
    type: SEND_CONTRACT_FAILED,
    error
  }
}

export function sendContractSucceeded() {
  return {
    type: SEND_CONTRACT_SUCCEEDED
  }
}

export function asignarEstadoCuestionarios({inclusion,socioCampana,socioBasico,menosSaludable,salida,salidaCampaign}){
    return {
        type: SET_ESTADO_CUESTIONARIOS,
        inclusion,
        socioCampana,
        socioBasico,
        menosSaludable,
        salida,
        salidaCampaign
    } 
}

export const actions = {
  getQuestions,
    getPais,
  getQuestionsId,
  getQuestionsFailed,
  getQuestionsSucceeded,
  userIsSuitable,
  userIsSuitableFailed,
  userIsSuitableSucceeded,
  sendContract,
  sendContractFailed,
  sendContractSucceeded,
  asignarEstadoCuestionarios
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

  [GET_QUESTIONS]: (state, action) => ({
    ...state,
    getQuestionsStatus : API_REQUEST_STATUS_LOADING,
    getQuestionsError : -1
  }),

  [GET_QUESTIONS_FAILED]: (state, action) => ({
    ...state,
    getQuestionsStatus : API_REQUEST_STATUS_FAILED,
    getQuestionsError : action.error
  }),

  [GET_QUESTIONS_SUCCEEDED]: (state, action) => ({
    ...state,
    getQuestionsStatus : API_REQUEST_STATUS_SUCCEEDED,
    getQuestionsError : -1,
    data: action.payload,
    questionsLoaded: true
  }),

  [GET_QUESTIONS_ID]: (state, action) => ({
      ...state,
      getQuestionsStatus : API_REQUEST_STATUS_LOADING,
      getQuestionsError : -1
  }),

  [GET_QUESTIONS_ID_FAILED]: (state, action) => ({
      ...state,
      getQuestionsStatus : API_REQUEST_STATUS_FAILED,
      getQuestionsError : action.error
  }),

  [GET_QUESTIONS_ID_SUCCEEDED]: (state, action) => ({
      ...state,
      getQuestionsStatus : API_REQUEST_STATUS_SUCCEEDED,
      getQuestionsError : -1,
      quest: action.payload
  }),

  [USER_IS_SUITABLE]: (state, action) => ({
    ...state,
    userIsSuitableStatus : API_REQUEST_STATUS_LOADING,
    userIsSuitableError : -1
  }),

  [USER_IS_SUITABLE_FAILED]: (state, action) => ({
    ...state,
    userIsSuitableStatus : API_REQUEST_STATUS_FAILED,
    userIsSuitableError : action.error
  }),

  [USER_IS_SUITABLE_SUCCEEDED]: (state, action) => ({
    ...state,
    userIsSuitableStatus : API_REQUEST_STATUS_SUCCEEDED,
    userIsSuitableError : -1
  }),

  [SEND_CONTRACT]: (state, action) => ({
    ...state,
    sendContractStatus : API_REQUEST_STATUS_LOADING,
    sendContractError : -1
  }),

  [SEND_CONTRACT_FAILED]: (state, action) => ({
    ...state,
    sendContractStatus : API_REQUEST_STATUS_FAILED,
    sendContractError : action.error
  }),

  [SEND_CONTRACT_SUCCEEDED]: (state, action) => ({
    ...state,
    sendContractStatus : API_REQUEST_STATUS_SUCCEEDED,
    sendContractError : -1
  }),

    [GET_PAIS]: (state, action) => ({
        ...state,
        getPaisStatus : API_REQUEST_STATUS_LOADING,
        getPaisError : -1
    }),

    [GET_PAIS_FAILED]: (state, action) => ({
        ...state,
        getPaisStatus : API_REQUEST_STATUS_FAILED,
        getPaisError : action.error
    }),

    [GET_PAIS_SUCCEEDED]: (state, action) => ({
        ...state,
        getPaisStatus : API_REQUEST_STATUS_SUCCEEDED,
        getPaisError : -1,
        paises: action.payload
    }),

    [SET_ESTADO_CUESTIONARIOS]: (state, {inclusion,socioCampana,socioBasico,menosSaludable,salida,salidaCampaign}) => ({
        ...state,
        estadoCuestionarios: {
            inclusion,
            socioCampana,
            socioBasico,
            menosSaludable,
            salida,
            salidaCampaign
        }
    })
}

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  data : {
    questInclusion: {},
    questSocioDemografico: {},
    questSalida: {
      pkCuestionario: 0,
      descripcion: '',
      activo: true,
      preguntas: [
        {
            pkPregunta: 28,
            descripcion: "",
            activo: true,
            opciones: [
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                },
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                },
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                },
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                },
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                }
            ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
          pkPregunta: 28,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              },
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },
        {
            pkPregunta: 0,
            descripcion: "",
            activo: true,
            opciones: [
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                }
            ]
        },{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
        ,{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
        ,{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
      ]
    },
    questCampaign: {},
    questSalidaCampaign: {
      pkCuestionario: 0,
      descripcion: '',
      activo: true,
      preguntas: [
        {
            pkPregunta: 0,
            descripcion: "",
            activo: true,
            opciones: [
                {
                    pkOpcion: 0,
                    descripcion: "",
                    activo: true
                }
            ]
        },{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
        ,{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
        ,{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        },{
          pkPregunta: 0,
          descripcion: "",
          activo: true,
          opciones: [
              {
                  pkOpcion: 0,
                  descripcion: "",
                  activo: true
              }
          ]
        }
      ]
    },
    questCampaignSatisfaction: {
      pkCuestionario: 6,
      descripcion: "Cuestionario de Campaña",
      activo: true,
      preguntas: [
          {
              pkPregunta: 84,
              descripcion: "Me quedó claro que lo mejor es preferir los alimentos frescos que los procesados",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 289,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 290,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 291,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 292,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 293,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          },
          {
              pkPregunta: 85,
              descripcion: "Me explicó claramente cómo seleccionar los alimentos más saludables",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 294,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 295,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 296,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 297,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 298,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          },
          {
              pkPregunta: 86,
              descripcion: "Es ofensivo o me disgusta",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 299,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 300,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 301,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 302,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 303,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          },
          {
              pkPregunta: 87,
              descripcion: "Es adecuado para los niños, las niñas y los adolescentes",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 304,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 305,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 306,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 307,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 308,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          },
          {
              pkPregunta: 88,
              descripcion: "Me sentí identificado(a) con las fotografías e imágenes presentadas en los materiales de comunicación",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 309,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 310,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 311,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 312,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 313,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          },
          {
              pkPregunta: 89,
              descripcion: "Todos los niños, las niñas y los adolescentes de México deberían tener acceso a este material",
              activo: true,
              opciones: [
                  {
                      pkOpcion: 314,
                      descripcion: "Muy de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 315,
                      descripcion: "Algo de acuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 316,
                      descripcion: "Ni de acuerdo ni en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 317,
                      descripcion: "Algo en desacuerdo",
                      activo: true
                  },
                  {
                      pkOpcion: 318,
                      descripcion: "En desacuerdo",
                      activo: true
                  }
              ]
          }
      ]
    }
    },
    questionsLoaded: false,
    paises: [],
    quest: undefined,
  getQuestionsStatus : -1,
    getPaisStatus: -1,
    getPaisError: -1,
  getQuestionsError : -1,
  userIsSuitableStatus : -1,
  userIsSuitableError : -1,
  sendContractStatus : -1,
  sendContractError : -1,
  estadoCuestionarios: {
      inclusion: true,
      socioBasico: true,
      salida: true,
      socioCampana: true,
      menosSaludable: true,
      salidaCampaign: true,
  }
}

export default function questionReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/modules/module_questions.js